import Cookies from 'universal-cookie'

const cookies = new Cookies()

const listSuperUser = [
  'skyshi.andri@getcraft.com',
  'rahmat.zailani@getcraft.com',
  'patrick@getcraft.com',
  'reza@getcraft.com',
  'steve@getcraft.com',
  'jeffrey@getcraft.com',
  'alexm@getcraft.com',
  'tutu@getcraft.com',
  'darmawan@getcraft.com',
  'corry@getcraft.com',
  'budi@getcraft.com',
  'cetrin@getcraft.com',
  'sirius@getcraft.com',
  'rizky@getcraft.com',
  'qatest@getcraft.com',
  'gusti.yoga@getcraft.com',

  // INDONESIA
  'adhimono@getcraft.com',
  'adinda@getcraft.com',
  'anindhiya.firdaus@getcraft.com',
  'diah@getcraft.com',
  'farras@getcraft.com',
  'fya@getcraft.com',
  'getzly@getcraft.com',
  'greggy@getcraft.com',
  'natasha@getcraft.com',
  'nurani.shinanta@getcraft.com',
  'stefan@getcraft.com',
  'tito@getcraft.com',

  // PHILIPPINES
  'raffy@getcraft.com',
  'nina@getcraft.com',
  'jameson@getcraft.com',

  // SINGAPORE
  'christopher@getcraft.com',
  'shashwith@getcraft.com',

  // MALAYSIA
  'zuan@getcraft.com',
  'yasmin@getcraft.com',
  'alvin.see@getcraft.com',
]

function isAuthorized() {
  return cookies.get('token')
}

function getUserId() {
  return cookies.get('userId')
}

function destroyUser() {
  cookies.remove('token', { path: '/' })
  cookies.remove('userId', { path: '/' })
}

function requireAuth(nextState, replaceState) {
  if (!isAuthorized()) {
    replaceState({ pathname: '/signin' })
  }
}

function isLoggedOut(nexState, replaceState) {
  if (isAuthorized()) {
    replaceState({ pathname: '/' })
  }
}

function isSuperUser(user) {
  return listSuperUser.includes(user.email)
}

function isGetCraftAccount(email) {
  const emailDomain = email.split('@')[1]
  if (emailDomain === 'getcraft.com') {
    return true
  }
  return false
}

export {
  destroyUser,
  requireAuth,
  isLoggedOut,
  isAuthorized,
  getUserId,
  isSuperUser,
  isGetCraftAccount,
}
